import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { align } from '../../core/styles'
import { ether, grid, mg } from '../../core'

const PageTitle = ({ section, children, className, headerClassName }) => (
  <div className={ classnames(className, align.center) }>
    { section && ( <h4 className={ ether('heading-xxsmall--sans') }>{ section }</h4> ) }
    <h1 className={ headerClassName || ether('heading-large') }>{ children }</h1>
  </div>
)

PageTitle.propTypes = {
  section: PropTypes.string,
  className: PropTypes.string,
  headerClassName: PropTypes.string,
  children: PropTypes.node,
}

export default PageTitle
